import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'
import NameToDomain from 'views/company/NameToDomain'

export default [routeWithLayout({ main: NameToDomain, path: UrlProvider.getRawUrl('nameToDomain') })]
